import React from "react";
import GlobalStyles from 'styles/GlobalStyles';
import { css } from "styled-components/macro"; 


/* Use AnimationRevealPage as a wrapper component for your pages if you are building a custom one yourself */
import AnimationRevealPage from "helpers/AnimationRevealPage.js";

 import RestaurantLandingPage from "demos/RestaurantLandingPage.js";
import Signup from "pages/Signup";
/* Inner Pages */

import ComponentRenderer from "ComponentRenderer.js";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import ITU from "demos/ITU";
import BOGAZICI from "demos/BOGAZICI";
import SABANCI from "demos/SABANCI";
import MARMARA from "demos/MARMARA";
import STANFORD from "demos/STANFORD";
import SHEFIELD from "demos/SHEFIELD";
import MEF from "demos/MEF";
import BAU from "demos/BAU";
import PIRII from "demos/PIRII";
import BILGI from "demos/BILGI";
import ISTANBUL from "demos/ISTANBUL";
import USKUDAR from "demos/USKUDAR";
import BEYKENT from "demos/BEYKENT";
import TORINO from "demos/TORINO";
import BANGOR from "demos/BANGOR";
import GRONIGEN from "demos/GRONIGEN";
import ERASMUS from "demos/ERASMUS";
import BACONNI from "demos/BACONNI";
import HONGKONG from "demos/HONGKONG";
import SANTA from "demos/SANTA";
import YTU from "demos/YTU";
import DOGUS from "demos/DOGUS";
import IYTE from "demos/IYTE";
import MSKU from "demos/MSKU";
import HACETTEPE from "demos/HACETTEPE";
import KOC from "demos/KOC";
import KARADENIZ from "demos/KARADENIZ";
import EGE from "demos/EGE";
import ANTALYA from "demos/ANTALYA";
import FSMV from "demos/FSMV";
import MANCHESTER from "demos/MANCHESTER";
import TORONTO from "demos/TORONTO";



export default function App() {
  return (
    <>

      <BrowserRouter>
      <GlobalStyles />
      
      <Routes>
        <Route path="/" element={<RestaurantLandingPage />}/>
        <Route path="/itu" element={<ITU />}/>
        <Route path="/bogazici" element={<BOGAZICI />}/>
        <Route path="/sabanci" element={<SABANCI />}/>
        <Route path="/marmara" element={<MARMARA />}/>
        <Route path="/stanford" element={<STANFORD />}/>
        <Route path="/sheffield" element={<SHEFIELD />}/>
        <Route path="/mef" element={<MEF />}/>
        <Route path="/bau" element={<BAU />}/>
        <Route path="/piri" element={<PIRII />}/>
        <Route path="/bilgi" element={<BILGI />}/>
        <Route path="/istanbul" element={<ISTANBUL />}/>
        <Route path="/uskudar" element={<USKUDAR />}/>
        <Route path="/beykent" element={<BEYKENT />}/>
        <Route path="/torino" element={<TORINO />}/>
        <Route path="/bangor" element={<BANGOR />}/>
        <Route path="/gronigen" element={<GRONIGEN />}/>
        <Route path="/erasmus" element={<ERASMUS />}/>
        <Route path="/baconni" element={<BACONNI />}/>
        <Route path="/honkong" element={<HONGKONG />}/>
        <Route path="/santa" element={<SANTA />}/>
        <Route path="/ytu" element={<YTU />}/>
        <Route path="/dogus" element={<DOGUS />}/>
        <Route path="/iyte" element={<IYTE />}/>
        <Route path="/msku" element={<MSKU />}/>
        <Route path="/hacettepe" element={<HACETTEPE />}/>
        <Route path="/koc" element={<KOC />}/>
        <Route path="/karadeniz" element={<KARADENIZ />}/>
        <Route path="/ege" element={<EGE />}/>
        <Route path="/antalya" element={<ANTALYA />}/>
        <Route path="/fsm" element={<FSMV />}/>
        <Route path="/manc" element={<MANCHESTER />}/>
        <Route path="/toronto" element={<TORONTO />}/>
          <Route path="/Kaydol" element={<Signup/>} />
        
      </Routes>
    </BrowserRouter>
    </>
  );
}